module.exports = __webpack_public_path__ + "static/assets/66cc24a281b29c3cb6afe344e9159393.svg";